<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M10.8359 12.8346C10.8359 11.1061 10.8359 10.2419 11.3851 9.70497C11.9343 9.16797 12.8182 9.16797 14.5859 9.16797C16.3537 9.16797 17.2376 9.16797 17.7868 9.70497C18.3359 10.2419 18.3359 11.1061 18.3359 12.8346V14.668C18.3359 16.3965 18.3359 17.2607 17.7868 17.7976C17.2376 18.3346 16.3537 18.3346 14.5859 18.3346C12.8182 18.3346 11.9343 18.3346 11.3851 17.7976C10.8359 17.2607 10.8359 16.3965 10.8359 14.668V12.8346Z"
      fill="currentColor"
    />
    <path
      d="M1.66797 7.16797C1.66797 8.89647 1.66797 9.76072 2.21714 10.2976C2.76632 10.8346 3.6502 10.8346 5.41797 10.8346C7.18574 10.8346 8.06962 10.8346 8.6188 10.2976C9.16797 9.76072 9.16797 8.89647 9.16797 7.16797V5.33464C9.16797 3.60615 9.16797 2.74191 8.6188 2.20494C8.06962 1.66797 7.18574 1.66797 5.41797 1.66797C3.6502 1.66797 2.76632 1.66797 2.21714 2.20494C1.66797 2.74191 1.66797 3.60615 1.66797 5.33464V7.16797Z"
      fill="currentColor"
    />
    <path
      d="M10.8359 4.58464C10.8359 3.67864 10.8359 3.22564 10.9787 2.86831C11.1689 2.39186 11.5339 2.01333 11.9934 1.81598C12.3379 1.66797 12.7748 1.66797 13.6484 1.66797H15.5234C16.3971 1.66797 16.8339 1.66797 17.1784 1.81598C17.6379 2.01333 18.0029 2.39186 18.1932 2.86831C18.3359 3.22564 18.3359 3.67864 18.3359 4.58464C18.3359 5.49064 18.3359 5.94364 18.1932 6.30096C18.0029 6.77741 17.6379 7.15594 17.1784 7.35329C16.8339 7.5013 16.3971 7.5013 15.5234 7.5013H13.6484C12.7748 7.5013 12.3379 7.5013 11.9934 7.35329C11.5339 7.15594 11.1689 6.77741 10.9787 6.30096C10.8359 5.94364 10.8359 5.49064 10.8359 4.58464Z"
      fill="currentColor"
    />
    <path
      d="M1.66797 15.4167C1.66797 16.3227 1.66797 16.7757 1.81069 17.133C2.00099 17.6094 2.36601 17.988 2.82544 18.1853C3.17001 18.3333 3.60683 18.3333 4.48047 18.3333H6.35547C7.22911 18.3333 7.66593 18.3333 8.0105 18.1853C8.46997 17.988 8.83497 17.6094 9.02522 17.133C9.16797 16.7757 9.16797 16.3227 9.16797 15.4167C9.16797 14.5107 9.16797 14.0577 9.02522 13.7003C8.83497 13.2239 8.46997 12.8453 8.0105 12.648C7.66593 12.5 7.22911 12.5 6.35547 12.5H4.48047C3.60683 12.5 3.17001 12.5 2.82544 12.648C2.36601 12.8453 2.00099 13.2239 1.81069 13.7003C1.66797 14.0577 1.66797 14.5107 1.66797 15.4167Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>